<template>
	<div class="flex-centerize">
		<h3 class="reg pr-2">{{ headerText }}</h3>
		<ProjectSelect :disabled="readonly" :projects="projects" v-model="localValue" />
	</div>
</template>

<script>
import ProjectSelect from '@/components/Project/ProjectSelect/ProjectSelect.vue';
import VModelMixin from '@/mixins/VModelMixin';
import { isNullOrUndefined } from '@/utils/helpers';
import ProjectsService from '@/utils/projects-service';
export default {
	name: 'ChooseProject',
	mixins: [VModelMixin],
	props: {
		headerText: { type: String, default: 'Save in' },
		projects: { type: Array },
		readonly: { type: Boolean },
		autoSelectFirst: { type: Boolean },
		alwaysShowSelect: { type: Boolean },
	},
	components: { ProjectSelect },
	watch: {
		projects: {
			handler(newV) {
				if (this.autoSelectFirst && isNullOrUndefined(this.localValue) && newV.length > 0) {
					this.localValue = ProjectsService.getFirstPersonalProject(this.projects).id;
				}
			},
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped></style>
